/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const CogIcon: React.SFC = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(-1 -2)" strokeWidth="2" stroke="#FFF" fill="none" fillRule="evenodd">
        <path d="M10.0438426 22.314253L12 20.73356l1.9561574 1.580693c.9974448-.20867 1.9490313-.576294 2.8235723-1.0865344l.2940213-2.6253754 2.8395358-.3278927c.500041-.7506984.8910382-1.56896 1.159696-2.4321722l-1.887941-2.4090277 2.0577656-2.625725c-.1784937-.7503438-.447665-1.4729897-.8005475-2.1543923l-3.368509-.3889754-.394098-3.5189805c-.6119907-.3471313-1.261113-.625318-1.9367304-.8286828L12 6.1329412 9.2570774 3.9164947c-.6756173.2033648-1.3247397.4815515-1.9367304.8286828L6.926249 8.264158l-3.368509.3889753c-.3528825.6814026-.6220537 1.4040485-.8005474 2.1543922l2.0577655 2.625725-1.887941 2.4090278c.268658.8632122.6596552 1.6814738 1.1596962 2.4321722l2.8395358.3278927.2940213 2.6253754c.874541.5102403 1.8261275.8778643 2.8235723 1.0865343z"/>
        <circle cx="12" cy="13" r="3"/>
        </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Cog/Cog.tsx